import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { HelpService } from '../../../services/help.service';
import { GoogleAnalyticsService } from '../../../services/google-analytics.service';
import { arrayIsDefinedAndContainsKey } from '../../../shared/array-functions';
import { openModal, closeModal } from '../../../shared/modal-functions';
import { responseIsSuccess, onPhoneNumberEntered } from '../../../shared/helper-functions';
import { whitespaceValidator } from '../../../shared/whitespace-validator';
import { helpView } from '../help.static.data';

@Component({
  selector: 'app-contact-form',
  templateUrl: './contact-form.component.html',
  styleUrls: ['../../../app.component.css']
})
export class ContactFormComponent implements OnInit {
  // Static data
  helpView: any;
  // Control view  
  openModal: any;
  closeModal: any;
  modalTitle: string;
  modalBody: string;
  onPhoneNumberEntered: any;
  contactFormCompleted: boolean;
  // Required Fields Validation
  emptyRequiredFields: boolean;
  invalidPhoneNumber: boolean;
  // User data
  contactForm: FormGroup;
  product: any;

  @Input() 
  inputName: string;
  @Input() 
  inputEmail: string;

  constructor(public formBuilder: FormBuilder, private helpService: HelpService, public googleAnalyticsService: GoogleAnalyticsService) { 
    this.helpView = helpView;
    this.openModal = openModal
    this.closeModal = closeModal;
    this.onPhoneNumberEntered = onPhoneNumberEntered;
    this.contactFormCompleted = true;
  }

  ngOnInit() {
    this.contactForm = this.formBuilder.group({
      name: ['', [whitespaceValidator]],
      email: ['', [whitespaceValidator]],
      phoneNumber: ['', [Validators.required, whitespaceValidator]],
      subject: ['', [Validators.required, whitespaceValidator]],
      message: ['', [Validators.required, whitespaceValidator]]
    });
    this.inputName ? this.contactForm.controls['name'].setValue(this.inputName) :  '';
    this.inputEmail ? this.contactForm.controls['email'].setValue(this.inputEmail) : '';
  }

  selectProduct(product) {
    this.product = product;
  }

  submitContactForm() {
    this.phoneNumber && this.phoneNumber.value.length < 14 ? this.invalidPhoneNumber = true : this.invalidPhoneNumber = false;
    !this.product ? this.emptyRequiredFields = true : this.emptyRequiredFields = false;
    if(!this.emptyRequiredFields && !this.invalidPhoneNumber) {
      this.contactFormCompleted = false;
      const contactFormPayload = {
        name: this.name.value,
        email: this.email.value,
        phoneNumber: this.phoneNumber.value,
        subject: this.subject.value,
        product: this.product,
        message: this.message.value
      };
      this.helpService.submitContactForm(contactFormPayload).subscribe((response) => {
        if (responseIsSuccess(response) && arrayIsDefinedAndContainsKey(response, 'CMS_SAM_AddContactFormSubmit') && response['CMS_SAM_AddContactFormSubmit'][0]['ContactFormSubmitRequest'] === 'True') {
        this.contactForm.reset();
        this.product = undefined;
        this.closeModal('#contactFormModal');
        this.openModal('#responseHelpModal');
        this.modalTitle = helpView.successContactFormResponseModal.title;
        this.modalBody = helpView.successContactFormResponseModal.body;
        } else {
          this.openModal('#responseHelpModal');
          this.modalTitle = helpView.errorContactFormResponseModal.title;
          this.modalBody = helpView.errorContactFormResponseModal.body;
        }
        this.contactFormCompleted = true;
      });
    }
  }

  submitGAEvent(eventCategory, eventAction, eventLabel) {
    this.googleAnalyticsService.emitEvent(eventCategory, eventAction, eventLabel, null);
  }

  get name() { return this.contactForm.get('name'); }
  get email() { return this.contactForm.get('email'); }
  get phoneNumber() { return this.contactForm.get('phoneNumber'); }
  get subject() { return this.contactForm.get('subject'); }
  get message() { return this.contactForm.get('message'); }

}



// WEBPACK FOOTER //
// /codebuild/output/src4156872633/src/src/app/components/help/contact-form/contact-form.component.ts